import AnalyticsFacade from "./facade/WarrantyServiceFacade";
export default AnalyticsFacade;
export * as AnalyticsTypes from "./types/types";
